import { render, staticRenderFns } from "./RecoveriesAggregations.vue?vue&type=template&id=3e4aeb4c&"
import script from "./RecoveriesAggregations.vue?vue&type=script&lang=js&"
export * from "./RecoveriesAggregations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports